import { render, staticRenderFns } from "./wf-currency-entry-edit.vue?vue&type=template&id=6ae9d922&scoped=true&"
import script from "./wf-currency-entry-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-currency-entry-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-currency-entry-edit.vue?vue&type=style&index=0&id=6ae9d922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae9d922",
  null
  
)

export default component.exports